export default __webpack_public_path__ + "static/media/manufacture2.83109543.webp";